export { default as EntityAttributeComponent } from './EntityAttributeComponent';
